import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  constructor(private g: Globals) {
    this.g.page = "Reports";
  }

  ngOnInit() {
  }

}
